'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><circle cx={8} cy={8} r={8} fill="currentColor" /><path fill="#fff" d="M6.98 11.295q0-.42.3-.709.298-.286.72-.287.45 0 .732.287a.95.95 0 0 1 .288.71.98.98 0 0 1-.282.72q-.28.275-.738.275-.427 0-.727-.28a.95.95 0 0 1-.293-.716m.082-4.418V3.731h1.899v3.146l-.41 2.749H7.473z" /></svg>;
const IconCircleError = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconCircleError;